import React from 'react';

import { SkeletonWrapper, ShimmerWrapper, Shimmer } from './SkeletonStyle';

export interface SkeletonProps {
  width?: number;
  height?: number;
  borderRadius?: number;
  marginBottom?: number;
  marginRight?: number;
  marginLeft?: number;
}

const Skeleton = ({
  width,
  height,
  borderRadius,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
}: SkeletonProps): React.JSX.Element => {
  return (
    <SkeletonWrapper
      width={width}
      height={height}
      borderRadius={borderRadius}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
    >
      <ShimmerWrapper>
        <Shimmer />
      </ShimmerWrapper>
    </SkeletonWrapper>
  );
};

export default Skeleton;
